import React from 'react';

const SkeletonBase = ({ className = '' }) => (
  <div className={`shimmer rounded-lg ${className}`} />
);

export const SkeletonText = ({ width = 'w-full', height = 'h-4', className = '' }) => (
  <SkeletonBase className={`${width} ${height} ${className}`} />
);

export const SkeletonCircle = ({ size = 'w-10 h-10', className = '' }) => (
  <SkeletonBase className={`${size} rounded-full ${className}`} />
);

export const SkeletonTable = ({ rows = 5, cols = 5 }) => (
  <div className="glass rounded-2xl overflow-hidden border border-gray-100 dark:border-neutral-800">
    <div className="p-4 border-b border-gray-100 dark:border-neutral-800">
      <div className="flex gap-4">
        {Array.from({ length: cols }).map((_, i) => (
          <SkeletonText key={i} width="flex-1" height="h-4" />
        ))}
      </div>
    </div>
    <div className="divide-y divide-gray-100 dark:divide-neutral-800">
      {Array.from({ length: rows }).map((_, row) => (
        <div key={row} className="p-4 flex items-center gap-4">
          <SkeletonCircle size="w-8 h-8" />
          {Array.from({ length: cols - 1 }).map((_, col) => (
            <SkeletonText key={col} width="flex-1" height="h-4" />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonPage = () => (
  <div className="space-y-6 animate-fade-in">
    <div className="space-y-2">
      <SkeletonText width="w-48" height="h-8" />
      <SkeletonText width="w-72" height="h-4" />
    </div>
    <SkeletonTable rows={8} cols={6} />
  </div>
);

const SkeletonLoader = ({ variant = 'page', ...props }) => {
  switch (variant) {
    case 'table':
      return <SkeletonTable {...props} />;
    case 'page':
    default:
      return <SkeletonPage {...props} />;
  }
};

export default SkeletonLoader;
